import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { InteriorAIPage } from './pages/InteriorAIPage';
render(<BrowserRouter data-id="element-487">
    <Routes data-id="element-488">
      <Route path="/" element={<App data-id="element-490" />} data-id="element-489" />
      <Route path="/interior-ai" element={<InteriorAIPage data-id="element-492" />} data-id="element-491" />
    </Routes>
  </BrowserRouter>, document.getElementById('root'));